export const SUPPORTED_LOCALES = ['en', 'ru', 'zh-Hans'] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const TRANSLATION_NAMESPACES = [
  'common',
  'home',
  'auth',
  'navigation',
  'onboarding',
  'billing',
  'developerApi',
  'account',
  'validation',
  'studio',
] as const;

export type TranslationNamespace = (typeof TRANSLATION_NAMESPACES)[number];

export type TranslationValue =
  string | TranslationTree | readonly TranslationValue[];
export type TranslationTree = { readonly [key: string]: TranslationValue };

export type TranslationResources = Record<
  TranslationNamespace,
  TranslationTree
>;
